/* eslint-disable */

import axios from 'axios';

const baseURL = process.env.VUE_APP_API_BASE_URL;
export default {
  state: {
    getInterviewQuizState: {},
    getInterviewInfoByIdState:{},
    getIvQuizUnitQansInfoState:{},
    getIvQuizUniInfoByIdState:{}
  },
  mutations: {
    getInterviewQuizMutation(state, response) {
      state.getInterviewQuizState = response;
    },
    getInterviewInfoByIdMutation(state, response) {
      state.getInterviewInfoByIdState = response;
    },
    getIvQuizUnitQansInfoMutation(state, response) {
      state.getIvQuizUnitQansInfoState = response;
    },
    getIvQuizUniInfoByIdMutation(state, response) {
      state.getIvQuizUniInfoByIdState = response;
    },
  },
  actions: {
    // POst Quiz Unit Q Ans List
    postIvQuizUnitQansInfoAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/quizzes/admin/interview-question/', payload).then((response) => {
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Update Quiz Unit Q Ans List
    updateIvQuizUnitQansInfoAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch('/quizzes/admin/interview-question/' + payload.data.id + '/', payload.data.data).then((response) => {
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Delete Quiz Unit Q Ans List
    deleteIvQuizUnitQansInfoAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.delete('/quizzes/admin/interview-question/' + payload.id + '/').then((response) => {
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Get Quiz Unit Q Ans Info By ID
    getIvQuizUnitQansInfoByIdAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/quizzes/admin/interview-question/'  + payload.id + '/').then((response) => {
          context.commit('getIvQuizUnitQansInfoMutation', response.data);
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Get Quiz Unit Q Ans List
    getIvQuizUnitQansInfoAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/quizzes/admin/interview-question/').then((response) => {
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Update Quiz Unit List
    updateIvQuizUniInfoAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch('/quizzes/admin/interview-unit/' + payload.data.id + '/', payload.data.data).then((response) => {
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Delete Quiz Unit List
    deleteIvQuizUniInfoAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.delete('/quizzes/admin/interview-unit/' + payload.id + '/').then((response) => {
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Get Quiz Unit Info By ID
    getIvQuizUniInfoByIdAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/quizzes/admin/interview-unit/'  + payload.id + '/').then((response) => {
          context.commit('getIvQuizUniInfoByIdMutation', response.data.data);
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Get Quiz Unit List
    getIvQuizUniInfoAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/quizzes/admin/interview-unit/').then((response) => {
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Post Quiz Unit List
    postIvQuizUniInfoAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/quizzes/admin/interview-unit/', payload).then((response) => {
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Get Quiz List
    getInterviewQuizListAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/quizzes/admin/interview-quiz/').then((response) => {
          context.commit('getInterviewQuizMutation', response.data);
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Post Quiz List
    postInterviewQuizInfoAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/quizzes/admin/interview-quiz/', payload).then((response) => {
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Patch Quiz List
    updateInterviewQuizInfoAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch('/quizzes/admin/interview-quiz/' + payload.data.id + '/', payload.data.data).then((response) => {
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Get By ID Quiz List
    getInterviewInfoByIdAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/quizzes/admin/interview-quiz/' + payload.id + '/').then((response) => {
          context.commit('getInterviewInfoByIdMutation', response.data);
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Post Quiz List
    deleteInterviewInfoByIdAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.delete('/quizzes/admin/interview-quiz/' + payload.id + '/').then((response) => {
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
  },
  getters: {
    getInterviewQuizGetter: state => state.getInterviewQuizState,
    getInterviewInfoByIdGetter: state => state.getInterviewInfoByIdState,
    getIvQuizUnitQansInfoGetter: state => state.getIvQuizUnitQansInfoState,
    getIvQuizUniInfoByIdGetter: state => state.getIvQuizUniInfoByIdState
  }
}